const join = (parts: (string | null | undefined)[]) =>
  parts
    .map((p) => (p ?? '').trim())
    .filter(Boolean)
    .join(' ');

// mapsSearchUrl: Adresse in Google Maps öffnen (Maps URLs, ohne Schlüssel) – zum schnellen Gegenprüfen einer Adresse.
export function mapsSearchUrl(...parts: (string | null | undefined)[]): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(join(parts))}`;
}

// mapsDirectionsUrl: Navigation zur Adresse starten (auf dem Handy öffnet sich die Karten-App).
export function mapsDirectionsUrl(...parts: (string | null | undefined)[]): string {
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(join(parts))}&travelmode=driving`;
}
